
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.66.66c.74-.74 1.94-.74 2.68 0l18 18a1.895 1.895 0 1 1-2.68 2.68l-18-18C-.08 2.6-.08 1.4.66.66z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.34.66c.74.74.74 1.94 0 2.68l-18 18a1.895 1.895 0 0 1-2.68-2.68l18-18c.74-.74 1.94-.74 2.68 0z"}})])
          )
        }
      }
    